/**
 * Single source of truth for online/offline used by apiClient without React.
 * OfflineContext + useOnline keep this in sync with Capacitor Network + browser events.
 */
let online = typeof navigator !== "undefined" ? navigator.onLine : true;

export function setOnline(value: boolean): void {
    online = value;
}

export function getOnline(): boolean {
    return online;
}
